<template>
    <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item" v-if="currentPage > 1">
            <a class="page-link" aria-label="Previous" v-on:click.prevent="navigate(currentPage - 1)">
              <span aria-hidden="true">«</span>
            </a>
          </li>
          <li class="page-link">
            {{ currentPage }} de {{ lastPage }}
          </li>
          <li v-if="currentPage < lastPage">
            <a class="page-link" aria-label="Next" v-on:click.prevent="navigate(currentPage + 1)">
              <span aria-hidden="true">»</span>
            </a>
          </li>
        </ul>
        <p>Exibindo página {{ currentPage }} de {{total}}, total de {{totalRegistros}} registros.</p>
    </nav>
</template>

<script>
import {eventType} from '@/components/shared/eventType'
export default {
  name: 'PaginationAlternative',
  props: [
    'resource',
    'totalPorPagina'
  ],
  created () {
    this.$store.dispatch('getRegistrosAlternative', {resource: this.resource, limit: this.totalPorPagina})
  },
  mounted () {
    eventType.$on('app', (result) => {
      this.filtros = result
    })
  },
  data: function () {
    return {
      active: 1,
      filtros: []
    }
  },
  computed: {
    registros () {
      return this.$store.state.paginationAlternative.getList
    },
    totalRegistros () {
      return this.registros.total || 0
    },
    total () {
      return this.registros.last_page || 0
    },
    currentPage () {
      return this.registros.current_page
    },
    lastPage () {
      return this.registros.last_page
    }
  },
  methods: {
    navigate (n) {
      this.active = n
      let config = {
        resource: this.resource,
        limit: this.totalPorPagina,
        page: n,
        filtros: this.filtros
      }

      this.$store.dispatch('getRegistrosSearchAlternative', config)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/PaginationAlternative.vue